import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from './fileEnvironmentApiDef';

const call = async (): Promise<IFinalResponse> => {
  const result: IFinalResponse = {
    success: false,
    data: null,
    errors: undefined,
    metadata: null,
  };

  try {
    const timestamp = new Date().getTime();
    const init: InitApiType = {
      params: {
        t: timestamp,
      },
    };

    const response = await get(
      Definitions.API_DOMAIN,
      Definitions.ENDPOINT_API_PATH,
      Definitions.API_CREDENTIALS_TYPE,
      init,
    );
    result.success = true;
    result.data = response.response;
  } catch (error) {
    result.success = false;
    result.data = null;
    result.errors = [error];
  }

  return result;
};

export default { call, definitions: Definitions };
